export const SESSION_PREFIX = 'RLX.Local.';

export function serializeValue (_value) {
  return JSON.stringify({ _value });
}

export function deserializeValue (data) {
  if (typeof data === 'undefined')
    throw new TypeError('deserializeValue(data): broh, data needs to at least be *defined*. Got ' + data);
  const raw = JSON.parse(data);
  return raw ? raw._value : null;
}

export function sessionSave (key, value = null) {
  if (typeof key !== 'string' || !key.length)
    throw new TypeError('sessionSave: key needs to be a string broh');
  return sessionStorage.setItem(SESSION_PREFIX + key, serializeValue(value))
};

export function sessionLoad (key) {
  if (typeof key !== 'string' || !key.length)
    throw new TypeError('sessionSave: key needs to be a string broh');
  return deserializeValue(sessionStorage.getItem(SESSION_PREFIX + key));
}



// WEBPACK FOOTER //
// ./client/Core/Utils/Session.js